<template>
  <q-card flat>
    <q-card-actions>
      <q-uploader
          :factory="factoryFn"
          ref="uploader"
          @uploaded="onUploaded"
          @finish="onUploadFinished"
          accept=".pdf, image/*"
          method="POST"
          :filter="checkFileType"
          @rejected="onRejected"
          label="بارگذاری سند در سرویس فایل"
          bordered
          :multiple="multiple"
          max-file-size="100000000"/>
    </q-card-actions>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "UploadFile",
  props: {
    remotePath: {
      type: String,
      required: true
    },
    fileName: {
      type: String,
      required: true
    },
    fileKind: {
      type: Number,
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  methods: {
    ...mapActions({}),
    factoryFn() {
      return {
        url: `${this.$store.state.baseUrl}/upload_file/${this.remotePath}/${this.fileName}_${this.fileKind}.pdf`,
        method: 'POST',
        headers: [
          {name: 'Authorization', value: `${this.$store.state.jwtType} ${this.$store.state.accessToken}`}
        ]
      }
    },
    checkFileType(files) {
      return files.filter(file => file.type === 'application/pdf')
    },
    onUploaded() {
    },
    onUploadFinished() {
      this.$emit('uploaded-finish', {filename: this.fileName, fileKind: this.fileKind})
    },
    onRejected(rejectedEntries) {
      console.log(rejectedEntries)
    }
  },
  computed: {},
  watch: {},
  created() {

  }
}
</script>

<style scoped>

</style>